export const Operation = Object.freeze({
    REPO_CREATION: 'REPO_CREATION',
    NORMAL_QNA: 'QNA',
    PERSONA_PROMPTS: 'PERSONA PROMPTS',
});

export const RepoCreationPrompts = Object.freeze({
    VISION_REPRESENTATION: 'VISION_REPRESENTATION',
    RAG: 'RAG',
});
